<span class="simple-error-snackbar">
  {{ message | translate }}
</span>
